<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    class="modal-field-list-view is-multiple-detail"
  >
    <!-- Title -->
    <div class="modal-title">
      <h4 class="title">
        Properties
        <div class="title-badge">Field on Detail View</div>
      </h4>

      <div class="wrap-type">
        <img src="@/assets/new-form-ui/text.svg">
        <div class="text-type">{{ title }}</div>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="wrap-content">
      <!-- Parse Variable -->
      <div class="section-field input-field">
        <p class="title-section">Parse Value To</p>

        <b-form :class="{'error-input' : $v.dataSetup.variable.$error}">
          <label> Variable </label>
          <j-single-select
            v-model="dataSetup.variable"
            :options="options"
            :placeholder="'Select Variable'"
            label="label"
          />
        </b-form>
      </div>
    </div>

    <!-- Button -->
    <div class="d-flex justify-content-end mt-2">
      <button
        class="button-border mr-2"
        @click="$emit('close-modal')"
      >
        Close
      </button>
      <button
        :disabled="!dataSetup.variable"
        class="button-blue"
        @click="submitForm"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    data: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Field',
    },
  },

  data() {
    return {
      dataSetup: {
        variable: null,
      },
    };
  },

  created() {
    if (this.data) this.dataSetup.variable = this.data;
  },

  methods: {
    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$emit('submit', this.dataSetup.variable);
      }
    },
  },

  validations() {
    return {
      dataSetup: {
        variable: {
          required,
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalTitleMultipleDetail.vue